var $ = jQuery.noConflict ();
var $window = jQuery (window);

var rtime;
var timeout = false;
var delta = 200;
var parallaxrunset = 0;

jQuery (window).on ('resize', function (){
    rtime = new Date ();
    if (timeout === false) {
        timeout = true;
        setTimeout (resizeend, delta);
    }
});

/*
 * Add your functions triggered after resize end
 */
function resizeend(){
    if (new Date () - rtime < delta) {
        setTimeout (resizeend, delta);
    } else {
        timeout = false;

        /* Make #content padding top whene use fixed menu - engine.js */
        fixedTopForHeader ();

        /* Bootstrap -  set same height for all .col* in .row-eq-height - engine.js */
        rowEQheight ();

        /* Bootstrap - full width element .full_width_element when use container for all page */
        fullWidthElement ();

        /* Update screen size in right bottom corner */
        screenSize ();

    }
}

function cookies(){

    if ($ ('.cookies-notifier').length > 0) {
        $ ('.cookies-notifier .button').on ('click tap', function (){
            $ ('.cookies-notifier').addClass ('close');
            $.cookie ('cookie-banner-custom', 'off', { expires: 30, path: '/' });
        });
        if ($.cookie ('cookie-banner-custom') == 'off') {
            $ ('.cookies-notifier').addClass ('close');
        }
    }
}

/*
 * Add your functions triggered after page ready
 */

function mobileBurger(){
    /* animated burger icon mobile*/
    $ ("#header .burger").on ("click", function (){
        var liItem = $ ("#header .menu-item-has-children");
        var submenu = $ ("#header .menu-item-has-children .sub-menu")
        $ (this).toggleClass ("active");
        $ ('nav').toggleClass ("active");
        $ ('body').toggleClass ('is-blocked');
        liItem.removeClass ('active');
        submenu.removeClass ('active');
        submenu.slideUp (0);
    });

    $ ("#header .menu-item-has-children").on ("click", function (e){

        e.stopPropagation ();
        var liItem = $ ("#header .menu-item-has-children");
        var submenu = $ ("#header .menu-item-has-children .sub-menu")
        var thisSubmenu = $ (this).find (".sub-menu");

        submenu.slideUp (400, 'linear');
        liItem.removeClass ('active');

        $ (this).toggleClass ("active");
        thisSubmenu.toggleClass ("active");

        if (thisSubmenu.hasClass ('active')) {
            thisSubmenu.slideDown (400, 'linear');
        } else {
            thisSubmenu.slideUp (400, 'linear');
            $ (this).removeClass ("active");

        }
    });

    $ (document).on ("click", function (e){
        if ($ (e.target).is ('.menu-item-has-children') === false || $ (e.target).is ('.burger') === false) {
            $ ('#header .sub-menu').removeClass ("active");
            $ ('#header .sub-menu').slideUp (400, 'linear');
            // $ ('nav').removeClass ("active");

        }
    });
}

jQuery (document).ready (function (){


    /* Show grid lines and screen width on right bottom corner - engine.js */
    screenSize ();
    showGridLines ();
    mobileBurger ();

    /* Make #content padding top whene use fixed menu - engine.js */
    fixedTopForHeader ();

    /* Bootstrap - scroll to colapsed element in acordeon - engine.js */
    scrollToColapsedElement ();

    /* Bootstrap - on hover show (slide) submenu - engine.js */
    toggleNavbarMethod ();

    /* Bootstrap - scroll to colapsed element in acordeon - engine.js */
    scrollToColapsedElement ();
    cookies ();

});

/*
 * Add your functions triggered after all media and page loaded
 */
jQuery (window).on ('load', function (){

    /* trigger resize to recomposition element after load */
    jQuery (window).trigger ('resize');

});

/* Global - scroll page to TOP */
function backToTop(){
    jQuery ("html, body").animate ({ scrollTop: 0 }, 1000);
}
